import { GetUsersDto, userControllerImpersonate } from "@/lib/gen-api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceDisguise } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";

export function ImpersonateUserButton({
  user,
  children,
}: {
  user: Pick<GetUsersDto["data"][number], "uuid" | "name" | "email">;
  children?: React.ReactNode;
}) {
  const handleImpersonate = async () => {
    try {
      // Call the impersonation endpoint
      const response = await userControllerImpersonate({
        path: {
          userUuid: user.uuid,
        },
      });

      // Store impersonation token in localStorage
      if (response.data?.impersonationToken) {
        localStorage.setItem(
          "99r-impersonation-token",
          response.data.impersonationToken,
        );
        toast.success("User impersonated successfully. Reloading...");
        setTimeout(() => {
          window.location.href = `/w`;
        }, 1000);
      } else {
        throw new Error("No impersonation token received");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to impersonate user");
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {children ?? (
          <Button variant="default" size="default" title="Impersonate">
            <FontAwesomeIcon icon={faFaceDisguise} />
            Impersonate
          </Button>
        )}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Impersonate {user.name || user.email}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Impersonate as {user.name || user.email}. To stop impersonating, log
            out.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            onClick={handleImpersonate}
            asChild
          >
            <Button size="sm">Impersonate</Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
